import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { TICKETS_ROUTE } from '../../../../../constants/Routes';
import { useProductTicketFooter } from './styles';

const ProductTicketFooter = ({ ...props }) => {
  const { mobile } = props;
  const classes = useProductTicketFooter({ mobile });
  return (
    <Box display="flex" padding="7px 16px" className={classes.container}>
      <Typography>
        Revisa el estado en &nbsp;
        <Link to={TICKETS_ROUTE}>Solicitudes de atención</Link>
      </Typography>
    </Box>
  );
};

ProductTicketFooter.propTypes = {
  mobile: PropTypes.bool,
};

export default ProductTicketFooter;
